import { html, LitElement } from 'lit-element';
import { CloseButtonText, Button } from '../common/Button.js';
import { QuestionModalMultipleChoice } from './QuestionModalMultipleChoice.js';
import { QuestionModalECR } from './QuestionModalECR.js';
import { QuestionModalMathInline } from './QuestionModalMathInline.js';
import { Markup } from '../common/MarkupWrapper.js';
import { SlotsWrapper } from '../common/SlotsWrapper.js';
import { defineElement, getItemConfigElement } from '../classifier/utils.js';

export const mapQuestionModal = item => {
  const { config } = item || {};
  const { markup } = config || {};
  const { element: elementTag, models } = getItemConfigElement(config);

  if (models.length > 1) {
    return html``;
  }

  switch (elementTag) {
    case 'multiple-choice':
      defineElement(
        'question-modal-multiple-choice',
        QuestionModalMultipleChoice
      );

      return html`<question-modal-multiple-choice
        .model=${models[0]}
      ></question-modal-multiple-choice>`;

    case 'explicit-constructed-response':
      defineElement('question-modal-ecr', QuestionModalECR);

      return html`<question-modal-ecr
        .model=${models[0]}
      ></question-modal-ecr>`;

    case 'math-inline':
      defineElement('question-modal-math-inline', QuestionModalMathInline);

      return html` <question-modal-math-inline
        .model=${models[0]}
        .markup=${markup}
      ></question-modal-math-inline>`;

    default:
      return html``;
  }
};

/**
 * @element question-modal
 * @prop {Object} item - { modalType, modalContent, modalTitle }
 * @prop {Number} questionNumber
 * @prop {Function} closeModal - callback to close modal
 */
export class QuestionModal extends LitElement {
  static get properties() {
    return {
      item: { type: Object },
      questionNumber: { type: Number },
      closeModal: { type: Function },
    };
  }

  constructor() {
    super();

    defineElement('ct-modal-button', Button);
    defineElement('markup-wrapper', Markup);
    defineElement('slots-wrapper', SlotsWrapper);
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { config } = this.item || {};
    const { markup } = config || {};
    const { models } = getItemConfigElement(config);
    const { prompt } = models[0] || {};

    let question = prompt;

    const markupSlots = models.map(
      model => html`<span
        class="markup-response-value"
        slot="${model.element.toLowerCase()}-${model.id}"
      >
        <div>Response area</div>
      </span>`
    );

    if (models.length > 1) {
      question = html` <div class="modal-response-content">
        <markup-wrapper .markup=${markup} .markupSlots="${markupSlots}">
        </markup-wrapper>
      </div>`;
    }

    const modalContent = mapQuestionModal(this.item);

    return html` <div class="modal">
      <div class="modal-content large">
        <div class="scrollable">
          <div class="modal-response-header">
            <div class="question-modal-title">
              <p><strong>Question ${this.questionNumber || 1}</strong></p>
              ${question === prompt
                ? html`<math-rendering-element
                    .label=${prompt}
                  ></math-rendering-element>`
                : question}
            </div>
            <button class="modal-close-x" @click=${this.closeModal}>X</button>
          </div>

          ${modalContent}
        </div>
        <div class="modal-close-button-container">
          <ct-modal-button
            .text=${CloseButtonText}
            .onClick=${this.closeModal}
          ></ct-modal-button>
        </div>
      </div>
    </div>`;
  }
}

export default QuestionModal;
